import { Children } from 'react'
import { Slider } from 'src/components/slider'
import { InterestsSliderProps } from './interestsSlider.types'
import { defaultSettings } from './interestsSlider.constants'
import { Wrapper } from './interestsSlider.styles'

const InterestsSlider = ({ children, settings = defaultSettings }: InterestsSliderProps) => {
  const count = Children.count(children)

  return (
    <Wrapper $centralize={count === 1}>
      <Slider settings={settings}>{children}</Slider>
    </Wrapper>
  )
}

export default InterestsSlider
